var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"fill":"currentColor","d":"M.428 12.173l.064 3.03 2.909-.25 8.38-9.667-2.95-2.781z"}})
}
var staticRenderFns = []

export { render, staticRenderFns }